import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { GoogleStorageService } from '@app/services/google-storage.service';
import { DepartmentsServices } from '../../../services/departments.services';
import moment from 'moment';

@Component({
    selector: 'app-files-by-departments',
    templateUrl: './files-by-departments.component.html',
    styleUrls: ['./files-by-departments.component.scss'],
    standalone: false
})
export class FilesByDepartamentsComponent implements OnInit {
  permissionAccess: boolean = false;
  constructor(
    private modal: NgbModal,
    private departmentServices: DepartmentsServices,
    private googleServices: GoogleStorageService,
    private _snackBar: MatSnackBar,
  ) { }

  formModal: any;
  filesByDepartment: any = [];

  fileToUpload: any;
  departments: any;
  load: boolean = false;

  fileName: any;
  fileSize: any;
  newName: any;

  buttonOn: boolean = true;

  WarningMsg: String = null;

  departmentIdCheck: any = [];

  percentages: any;

  departmentSelected: Array<[]>;

  departmentEmpty: boolean = false;
  departmentsLoaded: any = [];
  modalForm = new UntypedFormGroup({
    file: new UntypedFormControl('', Validators.required),
    name: new UntypedFormControl('', [Validators.required, Validators.maxLength(40)]),
    department: new UntypedFormControl('', Validators.required)
  });

  referenceToDelete: string = null
  fileNameToDelete: string = null

  ngOnInit(): void {
    this.verifyPermissionAccess();
    this.getDepartments();
  }

  getDepartments() {
    this.departmentServices.getDepartments().subscribe((response) => {
      response.data.forEach((dep) => {
        this.filesByDepartment[dep.id] = [];
      })

      this.departments = response.data;

    });
  }
  getFilesDepartment(departmentId: any) {

    this.filesByDepartment[departmentId] = null;

    this.departmentServices.getFilesByDepartament(departmentId).subscribe((res) => {

      this.departmentIdCheck.push(departmentId);
      this.departmentsLoaded.push({ id: departmentId, data: res.data });
      this.filesByDepartment[departmentId] = this.departmentsLoaded.filter(item => item.id == departmentId)[0].data;

      this.departmentEmpty = this.filesByDepartment[departmentId].length < 1

    })
  }
  
  isDepartmentEmpty(departmentId: any){
    return this.filesByDepartment[departmentId].length <= 0
  }

  showModal(modal) {
    this.modal.open(modal);
    this.load = false;
  }

  onFileSelected(event) {
    this.fileToUpload = event.target.files[0];
    this.newName = event.target.files[0].name.replace("_", "").replace("-", "").replace(" ", "");
    this.fileName = this.newName;
    this.fileSize = event.target.files[0].size;
    let maxSizeFile = 10000000;

    if (this.fileSize > maxSizeFile) {
      this.WarningMsg = "El archivo excede los 10Mb, seleccionar otro..."
      this.buttonOn = false;
    } else {
      this.WarningMsg = null;
      this.buttonOn = true;
    }
  }

  async saveData() {
    if (this.modalForm.valid) {
      this.load = true;
      let data = {
        'name': this.newName,
        'description': this.modalForm.controls.name.value,
        'bucket_name': 'files-mrpresta',
        'department_id': this.modalForm.controls.department.value,
        'created_at': moment().format("YYYY-MM-DD")
      };
      const reader = new FileReader();
      reader.readAsDataURL(this.fileToUpload);
      reader.onload = () => {
        data['file'] = reader.result;
        this.departmentServices.saveAndGeneratePdf(data).subscribe(response => {
          if (response.error) {
            this._snackBar.open(response.message, '', {
              duration: 3200,
              verticalPosition: 'bottom',
              horizontalPosition: "center"
            });
            return
          } 

          this._snackBar.open(`Archivo guardado: ${response.data}, la pagina se recargara`, '', {
            duration: 3200,
            verticalPosition: 'bottom',
            horizontalPosition: "center"
          });

          this.departmentIdCheck = [];
          this.modal.dismissAll();
          this.modalForm.get('name').setValue(null)
          this.modalForm.get('file').setValue(null)
          this.modalForm.get('department').setValue(null);

          setTimeout(() => {
            window.location.reload()
          }, 1500)
        });
      }
    } else {
      this._snackBar.open('informacion no valida', '', {
        duration: 3200,
        verticalPosition: 'bottom',
        horizontalPosition: "center"
      });
    }
  }


  showModalConfirmDelete(modal, fileName, url) {
    this.modal.open(modal);
    this.referenceToDelete = url;
    this.fileNameToDelete = fileName;
  }
  async deleteFile() {
    let reference = this.referenceToDelete;
    if (reference) {
      let file = reference.split('files-mrpresta/');
      let dataToDelete = {
        bucket_name: 'files-mrpresta',
        url: reference,
        file_name: this.fileNameToDelete
      };
      await this.googleServices.deleteDocGoogleCloud(dataToDelete).subscribe((res) => {
        if (!res.error) {
          this._snackBar.open(res.message, '', {
            duration: 3200,
            verticalPosition: 'bottom',
            horizontalPosition: "center"
          });
          this.modal.dismissAll();
        } else {
          this._snackBar.open(res.message, '', {
            duration: 3200,
            verticalPosition: 'bottom',
            horizontalPosition: "center"
          });
          this.modal.dismissAll();
        }
      })
    }
  }

  closeAnyModal() {
    this.modal.dismissAll();
  }

  verifyPermissionAccess() {
    let modulesPermission = JSON.parse(localStorage.getItem('modulesPermission'));

    if (modulesPermission.includes('admin_files_departament_mod')) {
      this.permissionAccess = true;
    }
  }
}
